import type { GraphQLTaggedNode } from 'relay-runtime';
import { graphql } from 'relay-runtime';

export const PopularFeedWithTimeGranularityStorageSnippetsQuery: GraphQLTaggedNode = graphql`
	query PopularFeedWithTimeGranularityStorageSnippetsQuery(
		$first: Int
		$after: String
		$timeGranularity: String = "default"
		$isRovoLLMEnabled: Boolean = false
	) {
		popularFeed(first: $first, after: $after, timeGranularity: $timeGranularity) {
			nodes {
				content {
					title
					id
					type
					subType
					emoji: properties(key: "emoji-title-published") {
						nodes {
							id
							value
						}
					}
					aiProperty(entryPoint: "CONFLUENCE_HOME_POPULAR_FEED") @include(if: $isRovoLLMEnabled) {
						errorMessage
						createdAt
						objectData
					}
					contentProperties {
						latest {
							generatedBy
						}
					}
					excerpt(length: 350)
					labels {
						nodes {
							name
						}
					}
					links {
						webui
					}
					space {
						alias
						id
						key
						name
					}
					history {
						createdDate
						createdBy {
							type
							displayName
							profilePicture {
								path
							}
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
						}
						ownedBy {
							type
							displayName
							profilePicture {
								path
							}
							... on KnownUser {
								accountId
							}
						}
					}
					metadata {
						lastModifiedDate
						comments {
							commentsCount
						}
						currentuser {
							favourited {
								isFavourite
							}
						}
					}
					version {
						friendlyWhen
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;
